import isString from "lodash/isString";
import formatUSDCurrency from "./formatUSD";

/**
 * Removes only apostrophes from unit size text, keeping whitespace
 * @param {string} unitSize - The unit size text
 * @returns {string} - Text with apostrophes removed
 */
export const removeApostrophesOnly = (unitSize) => (unitSize || '').replace(/'/g, '');

/**
 * Removes both whitespace and apostrophes from unit size text
 * @param {string} unitSize - The unit size text
 * @returns {string} - Text with whitespace and apostrophes removed
 */
export const removeWhitespaceAndApostrophes = (unitSize) => (unitSize || '').replace(/[\s']+/g, '');

/**
 * Formats unit size text based on whether it contains "long"
 * @param {string} unitSize - The unit size text to format
 * @returns {string} - Formatted unit size text
 */
export const formatUnitSize = (unitSize) => {
	if (!unitSize) return '';

	return unitSize.toLowerCase().includes('long')
		? removeApostrophesOnly(unitSize)
		: removeWhitespaceAndApostrophes(unitSize);
};

/**
 * Formats a number as USD currency
 * @param {number|string} amount - The amount to format
 * @param {Object} [options] - Formatting options
 * @param {boolean} [options.showDecimal=true] - Show cents when true
 * @returns {string} - Formatted currency string (e.g., "$123.45")
 */
export const formatUSD = (amount, { showDecimal = true } = {}) => {
	if (amount === null || amount === undefined || amount === "") {
		return formatUSDCurrency(0, { showDecimal });
	}

	const parsedAmount = Number(isString(amount) ? amount.replace(/,/g, "") : amount);
	return formatUSDCurrency(Number.isNaN(parsedAmount) ? 0 : parsedAmount, {
		showDecimal,
	});
};
